import React from "react";
import styles from "./Banner.module.css";
import { useAuth } from "../../../context/AuthContext";

export default function Banner() {
  
    const { setAuthModal, userdata } = useAuth();
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent2}>Contact </span>{" "}
            <span className={styles.accent}>Us</span>
          </h1>
          <p>
        We welcome academic collaborations, institutional partnerships, award nominations, research engagements, and governance-related communication.<br/><br/>
Our team is committed to maintaining professional responsiveness and institutional transparency.

          </p>
          
        </div>
      </div>
    </section>
  );
}
